import React, { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Typography } from "../../../components/__common/Typography/Typography";
import "./Consignment.scss";
import { useLocation } from "react-router-dom";
import { ROUTES_CONSIGNMENT_PAGE } from "../../../configs/layout";

const AnalyticsConsignment = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    const main = document.getElementById("main-body");
    if (main) {
      if (ROUTES_CONSIGNMENT_PAGE.includes(pathname)) {
        main.style.overflow = "hidden";
        main.style.height = "100vh";
        main.style.marginTop = "0";
        main.classList.add("consignmentPageBg");
      } else {
        main.style.overflow = "auto";
      }
    }
  }, [pathname]);

  const currentLang =
    typeof document === "undefined" ? "" : document.documentElement.lang;
  const isKo = currentLang === "ko";
  return (
    <div className="consignment" data-testid="analytics-consignment">
      <div className="table-container">
        <table cellSpacing="0">
          <tbody>
            <tr>
              <td colSpan={2}>
                <Typography
                  className={isKo ? "kr-character" : ""}
                  variant="body2"
                  weight="w400"
                >
                  {t("PRIVACY_BDP_CONSIGNMENT_COMPANY_KR")}
                </Typography>
              </td>
              <td colSpan={2}>
                <Typography
                  className={isKo ? "kr-character" : ""}
                  variant="body2"
                  weight="w400"
                >
                  {t("PRIVACY_BDP_CONSIGNMENT_COMPANY")}
                </Typography>
              </td>
            </tr>
            <tr>
              <td>
                <Typography
                  className={isKo ? "kr-character" : ""}
                  variant="body2"
                  weight="w400"
                >
                  {t("PRIVACY_SANALYTICS_CONSIGNMENT_CLOIT_KR")}
                </Typography>
              </td>
              <td>
                <Typography
                  className={isKo ? "kr-character" : ""}
                  variant="body2"
                  weight="w400"
                >
                  {t("PRIVACY_SANALYTICS_CONSIGNMENT_CLOIT_OPERATIONS_KR")}
                </Typography>
              </td>
              <td>
                <Typography
                  className={isKo ? "kr-character" : ""}
                  variant="body2"
                  weight="w400"
                >
                  {t("PRIVACY_SANALYTICS_CONSIGNMENT_CLOIT")}
                </Typography>
              </td>
              <td>
                <Typography
                  className={isKo ? "kr-character" : ""}
                  variant="body2"
                  weight="w400"
                >
                  {t("PRIVACY_SANALYTICS_CONSIGNMENT_CLOIT_OPERATIONS")}
                </Typography>
              </td>
            </tr>
            <tr>
              <td>
                <Typography
                  className={isKo ? "kr-character" : ""}
                  variant="body2"
                  weight="w400"
                >
                  <Trans
                    i18nKey="PRIVACY_BDP_CONSIGNMENT_GOOGLE_KR"
                    components={{
                      a: (
                        // eslint-disable-next-line
                        <a
                          href="https://cloud.google.com/terms/subprocessors"
                          target="_blank"
                          rel="noreferrer"
                        />
                      ),
                    }}
                  />
                </Typography>
              </td>
              <td>
                <Typography
                  className={isKo ? "kr-character" : ""}
                  variant="body2"
                  weight="w400"
                >
                  <Trans i18nKey="PRIVACY_BDP_CONSIGNMENT_GOOGLE_OPERATIONS_KR" />
                </Typography>
              </td>
              <td>
                <Typography
                  className={isKo ? "kr-character" : ""}
                  variant="body2"
                  weight="w400"
                >
                  <Trans
                    i18nKey="PRIVACY_BDP_CONSIGNMENT_GOOGLE"
                    components={{
                      a: (
                        // eslint-disable-next-line
                        <a
                          href="https://cloud.google.com/terms/subprocessors"
                          target="_blank"
                          rel="noreferrer"
                        />
                      ),
                    }}
                  />
                </Typography>
              </td>
              <td>
                <Typography
                  className={isKo ? "kr-character" : ""}
                  variant="body2"
                  weight="w400"
                >
                  <Trans i18nKey="PRIVACY_BDP_CONSIGNMENT_GOOGLE_OPERATIONS" />
                </Typography>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
      {/* <Typography    className={isKo ? "kr-character" : ""} variant="body2" className="consignment__date" weight="w500">
        <Trans
          i18nKey="PRIVACY_BDP_CONSIGNMENT_EFFECTIVE_DATE"
          values={{
            "%s": getConsignmentDate("2024년 4월 1일", "April 1, 2024"),
          }}
        />
      </Typography> */}
    </div>
  );
};

export default AnalyticsConsignment;
